<p>
  kw-spinner works!
</p>
